<template>
    <div class="theme-search-results-item-flight-sections">
        <div class="theme-search-results-item-flight-section">
            <div class="row row-no-gutter row-eq-height">
                <div class="col-md-10">
                    <div class="theme-search-results-item-flight-section-item">
                        <div class="row">
                            <div class="col-md-3">
                                <div class="theme-search-results-item-flight-section-path">
                                    <div class="theme-search-results-item-flight-section-path-fly-time">
                                        <p v-if="distanceCity != 0">
                                            
                                            {{ roundNumber(distanceCity) + ' کیلومتر ' }}
                                        </p>
                                        <!-- <p v-else>
                                            {{ roundNumber(distanct) + ' کیلومتر ' }}
                                        </p> -->
                                    </div>
                                    <div class="col-md-6">
                                        <div class="theme-search-results-item-flight-section-path-line-start">
                                            <span class="from-to">
                                                {{ splitedListTo[0] }}
                                            </span>
                                            <div
                                                class="theme-search-results-item-flight-section-path-line-title f-mobile">
                                                {{ splitedListTo[1] }}
                                            </div>

                                        </div>
                                        <div class="theme-search-results-item-flight-section-path-line">
                                            <span class="arrow-line-detail">
                                                <ion-icon name="arrow-forward-outline"></ion-icon>
                                            </span>
                                        </div>
                                        <div class="theme-search-results-item-flight-section-path-line-end">
                                            <span class="from-to">{{ splitedListFrom[0] }}</span>
                                            <!-- <div class="theme-search-results-item-flight-section-path-line-dot"></div> -->
                                            <div
                                                class="theme-search-results-item-flight-section-path-line-title f-mobile">
                                                {{ splitedListFrom[1] }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <h5 class="theme-search-results-item-flight-section-airline-title mt-5">ایران ترابر هیچ مسئولیتی در قبال پرداخت های احتمالی شما به عنوان کمیسیون به صاحبین بار نخواهد داشت</h5> -->
        </div>
    </div>
</template>
<script>
export default {
    props: [
        'distanceCity',
        'distanct',
        'fromCity',
        'toCity',
    ],
    methods: {
        roundNumber(value) {
            let val = (Math.round(value) / 1).toFixed(0).replace(".", ",");
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
    },
    computed: {
        splitedListFrom() {
            return this.fromCity.split(",");
        },
        splitedListTo() {
            return this.toCity.split(",");
        },
    }
}
</script>
<style></style>